import { createFileRoute } from '@tanstack/react-router'
import { AccountHomeLayout } from 'merchant-components';

export const Route = createFileRoute('/_merchant/_portal')({
  staleTime: 1000 * 60 * 30, // 30 minutes
  component: AccountHomeLayout,
})
